import { ActionsUnion, createAction } from "common/reducers/UtilsTypes";
import { IWindowData } from "common/records/Window";
import { FormUpdateEvent } from "common/reducers/rsfForm.actions";

export const RECEIVE_WINDOW = "@windows/RECEIVE_WINDOW";
export const RECEIVE_DRAFT_WINDOW = "@windows/RECEIVE_DRAFT_WINDOW";
export const UPDATE_OPENING = "@windows/UPDATE_OPENING";
export const RESET_WINDOW = "@windows/RESET_WINDOW";

export const WindowActions = {
  receiveWindow: (window: Partial<IWindowData>) => createAction(RECEIVE_WINDOW, { window }),
  /** Upsert a draft window into byId only (no lastSavedById), so reset can drop/revert it. */
  receiveDraftWindow: (window: Partial<IWindowData>) => createAction(RECEIVE_DRAFT_WINDOW, { window }),
  updateOpening: (event: FormUpdateEvent) => createAction(UPDATE_OPENING, { event }),
  resetWindow: (windowId: number) => createAction(RESET_WINDOW, { windowId }),
};

export type WindowActions = ActionsUnion<typeof WindowActions>;
